import { CardItem } from "../common/Card/Card";

export default function CardSplice(
    cards: Array<CardItem>,
    columns: number
) : CardItem[][] {
    let cardColumns = [];

    for (let i = 0; i < cards.length; i += columns) {
        cardColumns.push(cards.slice(i, i + columns));
    }

    const lastColumn = cardColumns[cardColumns.length - 1];

    if (lastColumn && lastColumn.length !== columns) {
        let count = (columns - lastColumn.length);

        while (count > 0) {
            lastColumn.push({id: count, content: null});
            count--;
        }
    }

    return cardColumns;
}